var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddPhotoAlternate = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2292 21.3542H3.64583V6.77083H13.0208V4.6875H3.64583C2.5 4.6875 1.5625 5.625 1.5625 6.77083V21.3542C1.5625 22.5 2.5 23.4375 3.64583 23.4375H18.2292C19.375 23.4375 20.3125 22.5 20.3125 21.3542V11.9792H18.2292V21.3542ZM10.1146 18.0521L8.07292 15.5937L5.20833 19.2708H16.6667L12.9792 14.3646L10.1146 18.0521ZM20.3125 4.6875V1.5625H18.2292V4.6875H15.1042C15.1146 4.69792 15.1042 6.77083 15.1042 6.77083H18.2292V9.88542C18.2396 9.89583 20.3125 9.88542 20.3125 9.88542V6.77083H23.4375V4.6875H20.3125Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddPhotoAlternate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_photo_alternate.ca0a50ad.svg";
export { ForwardRef as ReactComponent };